import { get, post } from '@/api/request'
import type { ApiResponse } from '@/api/request'
import type { MessageItem } from '@/types/api'

export interface UnreadCountPayload {
  unreadCount: number
}

export interface MessagesResponse {
  messages: MessageItem[]
  pagination: { page: number; limit: number; total: number; pages: number }
}

export const messagesApi = {
  async getMessages(params?: {
    page?: number
    limit?: number
    type?: string
  }): Promise<ApiResponse<MessagesResponse>> {
    const res = await get<MessagesResponse>('/messages', { params })
    return res.data
  },

  async getDetail(id: string): Promise<ApiResponse<MessageItem>> {
    const res = await get<MessageItem>(`/messages/${id}`)
    return res.data
  },

  async markAllAsRead(): Promise<ApiResponse<{ markedCount: number }>> {
    const res = await post<{ markedCount: number }>('/messages/read-all')
    return res.data
  },

  async getUnreadCount(): Promise<ApiResponse<UnreadCountPayload>> {
    const res = await get<UnreadCountPayload>('/messages/unread-count')
    return res.data
  },

  async getVapidKey(): Promise<ApiResponse<{ publicKey: string }>> {
    const res = await get<{ publicKey: string }>('/messages/push/vapid-key')
    return res.data
  },

  async subscribePush(subscription: PushSubscriptionJSON): Promise<ApiResponse> {
    const res = await post('/messages/push/subscribe', subscription)
    return res.data
  },

  async unsubscribePush(endpoint: string): Promise<ApiResponse> {
    const res = await post('/messages/push/unsubscribe', { endpoint })
    return res.data
  },
}
